import { cva } from 'class-variance-authority';

const autocompleteBaseStyles = [
    'absolute',
    'max-h-48',
    'right-0',
    'top-full',
    'border',
    'border-t-0',
    'shadow-md',
    'z-50',
    'w-full',
    'overflow-y-auto'
];

const autocompleteStylesSAG = cva([
    ...autocompleteBaseStyles,
    'bg-[#D1FFF2]',
    'border-[#005159]',

    'dark:bg-[#001F39]',
    'dark:border-[#00FFB9]'
]);

const autocompleteStylesSHS = cva([...autocompleteBaseStyles, 'bg-white', 'border-0', 'dark:bg-[#333333]']);

const inputBaseStyles = [
    'peer',
    'relative',
    'w-full',
    'select-none',
    'data-[focus=true]:ring-0',
    'rounded-sm',
    'py-2',
    'px-4',
    'text-base', // TODO: Check with Tom (18px in Figma seem to large)
    'border',

    'data-[float-label=true]:pb-0',
    'data-[float-label=true]:pt-4'
];

const inputStylesSAG = cva([
    ...inputBaseStyles,
    'text-[#000028]',

    'bg-[#EBF7F8]',
    'border-[#4C4C68]',
    'placeholder:text-[#4C4C68]',

    'hover:bg-[#D1FFF2]',
    'hover:border-[#005159]',
    'hover:placeholder:text-[#000028]',

    'data-[focus=true]:bg-[#D1FFF2]',
    'data-[focus=true]:border-[#4C4C68]',
    'data-[focus=true]:placeholder:text-[#4C4C68]',

    'data-[active=true]:bg-[#D1FFF2]',
    'data-[active=true]:border-[#005159]',

    'invalid:bg-[#FCCCD7]',
    'invalid:border-[#D72339]',
    'invalid:placeholder:text-[#000028]',
    'invalid:hover:bg-[#FCCCD7]',
    'invalid:hover:border-[#D72339]',
    'invalid:hover:placeholder:text-[#000028]',
    'invalid:data-[active=true]:bg-[#FCCCD7]',
    'invalid:data-[active=true]:border-[#D72339]',
    'invalid:data-[active=true]:placeholder:text-[#000028]',
    'invalid:data-[focus=true]:bg-[#FCCCD7]',
    'invalid:data-[focus=true]:border-[#D72339]',
    'invalid:data-[focus=true]:placeholder:text-[#000028]',

    'data-[invalid=true]:bg-[#FCCCD7]',
    'data-[invalid=true]:border-[#D72339]',
    'data-[invalid=true]:placeholder:text-[#000028]',
    'data-[invalid=true]:hover:bg-[#FCCCD7]',
    'data-[invalid=true]:hover:border-[#D72339]',
    'data-[invalid=true]:hover:placeholder:text-[#000028]',
    'data-[invalid=true]:data-[active=true]:bg-[#FCCCD7]',
    'data-[invalid=true]:data-[active=true]:border-[#D72339]',
    'data-[invalid=true]:data-[active=true]:placeholder:text-[#000028]',
    'data-[invalid=true]:data-[focus=true]:bg-[#FCCCD7]',
    'data-[invalid=true]:data-[focus=true]:border-[#D72339]',
    'data-[invalid=true]:data-[focus=true]:placeholder:text-[#000028]',

    'data-[disabled=true]:bg-[#EBF7F8]',
    'data-[disabled=true]:border-[#CCCCD4]',
    'data-[disabled=true]:placeholder:text-[#4C4C68]',
    'data-[disabled=true]:hover:bg-[#EBF7F8]',
    'data-[disabled=true]:hover:border-[#CCCCD4]',
    'data-[disabled=true]:hover:placeholder:text-[#4C4C68]',
    'data-[disabled=true]:data-[focus=true]:bg-[#EBF7F8]',
    'data-[disabled=true]:data-[focus=true]:border-[#CCCCD4]',
    'data-[disabled=true]:data-[focus=true]:placeholder:text-[#4C4C68]',

    'data-[read-only=true]:bg-white',
    'data-[read-only=true]:border-[#CCCCD4]',
    'data-[read-only=true]:placeholder:text-[#4C4C68]',
    'data-[read-only=true]:hover:bg-white',
    'data-[read-only=true]:hover:border-[#CCCCD4]',
    'data-[read-only=true]:hover:placeholder:text-[#4C4C68]',
    'data-[read-only=true]:data-[focus=true]:bg-white',
    'data-[read-only=true]:data-[focus=true]:border-[#CCCCD4]',
    'data-[read-only=true]:data-[focus=true]:placeholder:text-[#4C4C68]',

    'dark:text-white',

    'dark:bg-[#00183B]',
    'dark:border-[#B3B3BE]',
    'dark:placeholder:text-[#B3B3BE]',

    'dark:hover:bg-[#001F39]',
    'dark:hover:border-[#00FFB9]',
    'dark:hover:placeholder:text-white',

    'dark:data-[focus=true]:bg-[#001F39]',
    'dark:data-[focus=true]:border-[#00FFB9]',
    'dark:data-[focus=true]:placeholder:text-[#B3B3BE]',

    'dark:data-[active=true]:bg-[#001F39]',
    'dark:data-[active=true]:border-[#00FFB9]',

    'dark:invalid:bg-[#331131]',
    'dark:invalid:border-[#FF2640]',
    'dark:invalid:placeholder:text-[#FFFFFF]',
    'dark:invalid:hover:bg-[#331131]',
    'dark:invalid:hover:border-[#FF2640]',
    'dark:invalid:hover:placeholder:text-[#FFFFFF]',
    'dark:invalid:data-[active=true]:bg-[#331131]',
    'dark:invalid:data-[active=true]:border-[#FF2640]',
    'dark:invalid:data-[active=true]:placeholder:text-[#FFFFFF]',
    'dark:invalid:data-[focus=true]:bg-[#331131]',
    'dark:invalid:data-[focus=true]:border-[#FF2640]',
    'dark:invalid:data-[focus=true]:placeholder:text-[#FFFFFF]',

    'dark:data-[invalid=true]:bg-[#331131]',
    'dark:data-[invalid=true]:border-[#FF2640]',
    'dark:data-[invalid=true]:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:hover:bg-[#331131]',
    'dark:data-[invalid=true]:hover:border-[#FF2640]',
    'dark:data-[invalid=true]:hover:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:data-[active=true]:bg-[#331131]',
    'dark:data-[invalid=true]:data-[active=true]:border-[#FF2640]',
    'dark:data-[invalid=true]:data-[active=true]:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:data-[focus=true]:bg-[#331131]',
    'dark:data-[invalid=true]:data-[focus=true]:border-[#FF2640]',
    'dark:data-[invalid=true]:data-[focus=true]:placeholder:text-[#FFFFFF]',

    'dark:data-[disabled=true]:bg-[#262648]',
    'dark:data-[disabled=true]:border-[#4C4C68]',
    'dark:data-[disabled=true]:placeholder:text-[#737389]',
    'dark:data-[disabled=true]:hover:bg-[#262648]',
    'dark:data-[disabled=true]:hover:border-[#4C4C68]',
    'dark:data-[disabled=true]:hover:placeholder:text-[#737389]',
    'dark:data-[disabled=true]:data-[focus=true]:bg-[#262648]',
    'dark:data-[disabled=true]:data-[focus=true]:border-[#4C4C68]',
    'dark:data-[disabled=true]:data-[focus=true]:placeholder:text-[#737389]',

    'dark:data-[read-only=true]:bg-[#000028]',
    'dark:data-[read-only=true]:border-[#333353]',
    'dark:data-[read-only=true]:placeholder:text-[#B3B3BE]',
    'dark:data-[read-only=true]:hover:bg-[#000028]',
    'dark:data-[read-only=true]:hover:border-[#333353]',
    'dark:data-[read-only=true]:hover:placeholder:text-[#B3B3BE]',
    'dark:data-[read-only=true]:data-[focus=true]:bg-[#000028]',
    'dark:data-[read-only=true]:data-[focus=true]:border-[#333353]',
    'dark:data-[read-only=true]:data-[focus=true]:placeholder:text-[#B3B3BE]'
]);

const inputStylesSHS = cva([
    ...inputBaseStyles,
    'text-[#1a1a1a]',

    'bg-[#ededed]',
    'border-[#666666]',
    'placeholder:text-[#666666]',

    'hover:bg-[#ededed]',
    'hover:border-[#666666]',
    'hover:placeholder:text-[#666666]',

    'data-[focus=true]:bg-[#ededed]',
    'data-[focus=true]:border-[#666666]',
    'data-[focus=true]:placeholder:text-[#666666]',

    'data-[active=true]:bg-[#ededed]',
    'data-[active=true]:border-[#005159]',

    'invalid:bg-[#ededed]',
    'invalid:border-[#e7001e]',
    'invalid:placeholder:text-[#666666]',
    'invalid:hover:bg-[#ededed]',
    'invalid:hover:border-[#e7001e]',
    'invalid:hover:placeholder:text-[#666666]',
    'invalid:data-[active=true]:bg-[#ededed]',
    'invalid:data-[active=true]:border-[#e7001e]',
    'invalid:data-[active=true]:placeholder:text-[#666666]',
    'invalid:data-[focus=true]:bg-[#ededed]',
    'invalid:data-[focus=true]:border-[#e7001e]',
    'invalid:data-[focus=true]:placeholder:text-[#666666]',

    'data-[invalid=true]:bg-[#ededed]',
    'data-[invalid=true]:border-[#e7001e]',
    'data-[invalid=true]:placeholder:text-[#666666]',
    'data-[invalid=true]:hover:bg-[#ededed]',
    'data-[invalid=true]:hover:border-[#e7001e]',
    'data-[invalid=true]:hover:placeholder:text-[#666666]',
    'data-[invalid=true]:data-[active=true]:bg-[#ededed]',
    'data-[invalid=true]:data-[active=true]:border-[#e7001e]',
    'data-[invalid=true]:data-[active=true]:placeholder:text-[#666666]',
    'data-[invalid=true]:data-[focus=true]:bg-[#ededed]',
    'data-[invalid=true]:data-[focus=true]:border-[#e7001e]',
    'data-[invalid=true]:data-[focus=true]:placeholder:text-[#666666]',

    'data-[disabled=true]:bg-[#f8f8f8]',
    'data-[disabled=true]:border-[#c2c2c2]',
    'data-[disabled=true]:placeholder:text-[#4C4C68]',
    'data-[disabled=true]:hover:bg-[#f8f8f8]',
    'data-[disabled=true]:hover:border-[#c2c2c2]',
    'data-[disabled=true]:hover:placeholder:text-[#4C4C68]',
    'data-[disabled=true]:data-[focus=true]:bg-[#f8f8f8]',
    'data-[disabled=true]:data-[focus=true]:border-[#c2c2c2]',
    'data-[disabled=true]:data-[focus=true]:placeholder:text-[#4C4C68]',

    'data-[read-only=true]:bg-[#ededed]',
    'data-[read-only=true]:border-[#666666]',
    'data-[read-only=true]:placeholder:text-[#666666]',
    'data-[read-only=true]:hover:bg-[#ededed]',
    'data-[read-only=true]:hover:border-[#666666]',
    'data-[read-only=true]:hover:placeholder:text-[#666666]',
    'data-[read-only=true]:data-[focus=true]:bg-[#ededed]',
    'data-[read-only=true]:data-[focus=true]:border-[#666666]',
    'data-[read-only=true]:data-[focus=true]:placeholder:text-[#666666]',

    'dark:text-[#e6e6e6]',

    'dark:bg-[#1a1a1a]',
    'dark:border-[#999999]',
    'dark:placeholder:text-[#999999]',

    'dark:hover:bg-[#1a1a1a]',
    'dark:hover:border-[#999999]',
    'dark:hover:placeholder:text-[#999999]',

    'dark:data-[focus=true]:bg-[#1a1a1a]',
    'dark:data-[focus=true]:border-[#999999]',
    'dark:data-[focus=true]:placeholder:text-[#999999]',

    'dark:data-[active=true]:bg-[#1a1a1a]',
    'dark:data-[active=true]:border-[#999999]',

    'dark:invalid:bg-[#1a1a1a]',
    'dark:invalid:border-[#e7001e]',
    'dark:invalid:placeholder:text-[#999999]',
    'dark:invalid:hover:bg-[#1a1a1a]',
    'dark:invalid:hover:border-[#e7001e]',
    'dark:invalid:hover:placeholder:text-[#999999]',
    'dark:invalid:data-[active=true]:bg-[#1a1a1a]',
    'dark:invalid:data-[active=true]:border-[#e7001e]',
    'dark:invalid:data-[active=true]:placeholder:text-[#999999]',
    'dark:invalid:data-[focus=true]:bg-[#1a1a1a]',
    'dark:invalid:data-[focus=true]:border-[#e7001e]',
    'dark:invalid:data-[focus=true]:placeholder:text-[#999999]',

    'dark:data-[invalid=true]:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:border-[#e7001e]',
    'dark:data-[invalid=true]:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:hover:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:hover:border-[#e7001e]',
    'dark:data-[invalid=true]:hover:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:data-[active=true]:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:data-[active=true]:border-[#e7001e]',
    'dark:data-[invalid=true]:data-[active=true]:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:data-[focus=true]:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:data-[focus=true]:border-[#e7001e]',
    'dark:data-[invalid=true]:data-[focus=true]:placeholder:text-[#999999]',

    'dark:data-[disabled=true]:bg-[#242424]',
    'dark:data-[disabled=true]:border-[#3d3d3d]',
    'dark:data-[disabled=true]:placeholder:text-[#999999]',
    'dark:data-[disabled=true]:hover:bg-[#242424]',
    'dark:data-[disabled=true]:hover:border-[#3d3d3d]',
    'dark:data-[disabled=true]:hover:placeholder:text-[#999999]',
    'dark:data-[disabled=true]:data-[focus=true]:bg-[#242424]',
    'dark:data-[disabled=true]:data-[focus=true]:border-[#3d3d3d]',
    'dark:data-[disabled=true]:data-[focus=true]:placeholder:text-[#999999]',

    'dark:data-[read-only=true]:bg-[#1a1a1a]',
    'dark:data-[read-only=true]:border-[#999999]',
    'dark:data-[read-only=true]:placeholder:text-[#999999]',
    'dark:data-[read-only=true]:hover:bg-[#1a1a1a]',
    'dark:data-[read-only=true]:hover:border-[#999999]',
    'dark:data-[read-only=true]:hover:placeholder:text-[#999999]',
    'dark:data-[read-only=true]:data-[focus=true]:bg-[#1a1a1a]',
    'dark:data-[read-only=true]:data-[focus=true]:border-[#999999]',
    'dark:data-[read-only=true]:data-[focus=true]:placeholder:text-[#999999]'
]);

const autocompleteChipStylesSAG = cva([
    'border-[#005159]',
    'bg-[#D1FFF2]',
    'text-[#005159]',

    'dark:border-[#00FFB9]',
    'dark:bg-[#001F39]',
    'dark:text-[#00FFB9]'
]);

const autocompleteChipStylesSHS = cva([
    'border-[#666666]',
    'bg-[#ededed]',
    'text-[#666666]',

    'dark:border-[#ededed]',
    'dark:bg-[#1a1a1a]',
    'dark:text-[#ededed]'
]);

export {
    autocompleteStylesSAG,
    autocompleteStylesSHS,
    inputStylesSAG,
    inputStylesSHS,
    autocompleteChipStylesSAG,
    autocompleteChipStylesSHS
};
